import { FileText, Wrench, Truck, Car, Cog, Gauge, ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/siteData";

const ICONS = { FileText, Wrench, Truck, Car, Cog, Gauge };

export default function Services() {
  const scrollToAppointment = () => {
    const el = document.querySelector("#appointment");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="services" className="py-20 lg:py-32 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-14 items-center mb-14 lg:mb-20">
          <div className="lg:col-span-7">
            <div className="text-sm font-semibold uppercase tracking-widest text-blue-600 mb-4">Nos services</div>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl text-slate-900 tracking-tight">
              Tout pour votre véhicule, <br className="hidden sm:block" />
              <span className="text-blue-600">sous un même toit.</span>
            </h2>
            <p className="mt-6 text-lg text-slate-600 leading-relaxed">
              De la simple révision à la carte grise, en passant par le dépannage et la vente : on s&apos;occupe de tout, avec transparence et sérieux.
            </p>
          </div>

          <div className="lg:col-span-5">
            <div className="relative group">
              <div className="absolute -inset-2 bg-blue-600/30 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity" />
              <img
                src="https://customer-assets.emergentagent.com/job_garage-loss/artifacts/mz7dh9g4_CD2AB708-04E3-473E-8A07-1098C106DD4D.PNG"
                alt="Devanture Sphère Auto - Loos-en-Gohelle"
                className="relative w-full rounded-2xl shadow-2xl object-cover aspect-square ring-1 ring-slate-200"
                data-testid="services-storefront-image"
              />
              <div className="absolute bottom-4 left-4 right-4 bg-slate-900/85 backdrop-blur-md rounded-xl px-4 py-3 border border-white/10">
                <div className="text-[10px] uppercase tracking-widest text-blue-300 font-semibold">Notre centre auto</div>
                <div className="text-sm font-semibold text-white mt-0.5">55 rue Jules Supervielle — Loos-en-Gohelle</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((service, idx) => {
            const Icon = ICONS[service.icon] || Wrench;
            return (
              <button
                key={service.id}
                onClick={scrollToAppointment}
                className="group relative text-left bg-white border border-slate-200 rounded-2xl p-7 hover:shadow-xl hover:-translate-y-1 hover:border-blue-200 transition-all duration-300"
                data-testid={`service-card-${service.id}`}
              >
                <div className="flex items-start justify-between mb-5">
                  <div className="w-14 h-14 rounded-xl bg-blue-50 group-hover:bg-blue-600 flex items-center justify-center transition-colors duration-300">
                    <Icon className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-slate-300 group-hover:text-blue-600 group-hover:rotate-12 transition-all duration-300" />
                </div>
                <h3 className="font-heading font-bold text-xl text-slate-900 mb-3">{service.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{service.desc}</p>
                <div className="mt-5 text-xs font-semibold text-blue-600 opacity-0 group-hover:opacity-100 transition-opacity">
                  Prendre rendez-vous →
                </div>
              </button>
            );
          })}
        </div>

        {/* Promo strip */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="bg-slate-900 text-white rounded-2xl p-6 flex items-center gap-4" data-testid="promo-diag">
            <div className="w-12 h-12 rounded-lg bg-blue-600 flex items-center justify-center flex-shrink-0">
              <Gauge className="w-6 h-6 text-white" />
            </div>
            <div>
              <div className="font-heading font-bold text-lg">Diagnostic OFFERT</div>
              <div className="text-sm text-slate-300">Avant tout devis de réparation</div>
            </div>
          </div>
          <div className="bg-blue-600 text-white rounded-2xl p-6 flex items-center gap-4" data-testid="promo-devis">
            <div className="w-12 h-12 rounded-lg bg-white/20 flex items-center justify-center flex-shrink-0">
              <FileText className="w-6 h-6 text-white" />
            </div>
            <div>
              <div className="font-heading font-bold text-lg">Devis sous 24/48h</div>
              <div className="text-sm text-blue-100">Réponse rapide garantie</div>
            </div>
          </div>
          <div className="bg-white border-2 border-slate-900 rounded-2xl p-6 flex items-center gap-4" data-testid="promo-tow">
            <div className="w-12 h-12 rounded-lg bg-slate-900 flex items-center justify-center flex-shrink-0">
              <Truck className="w-6 h-6 text-white" />
            </div>
            <div>
              <div className="font-heading font-bold text-lg text-slate-900">Dépannage rapide</div>
              <div className="text-sm text-slate-600">Loos-en-Gohelle et alentours</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
